__turbopack_context__.v({
  "benefit-cell": "desktop-comparison-table-module-scss-module__2Ih1RW__benefit-cell",
  "benefit-cell-icon": "desktop-comparison-table-module-scss-module__2Ih1RW__benefit-cell-icon",
  "benefit-cell-title-image-container": "desktop-comparison-table-module-scss-module__2Ih1RW__benefit-cell-title-image-container",
  "benefit-title": "desktop-comparison-table-module-scss-module__2Ih1RW__benefit-title",
  "cell": "desktop-comparison-table-module-scss-module__2Ih1RW__cell",
  "header-cell": "desktop-comparison-table-module-scss-module__2Ih1RW__header-cell",
  "header-title": "desktop-comparison-table-module-scss-module__2Ih1RW__header-title",
  "last-cell": "desktop-comparison-table-module-scss-module__2Ih1RW__last-cell",
  "link": "desktop-comparison-table-module-scss-module__2Ih1RW__link",
  "plan-description": "desktop-comparison-table-module-scss-module__2Ih1RW__plan-description",
  "plan-image": "desktop-comparison-table-module-scss-module__2Ih1RW__plan-image",
  "plan-title": "desktop-comparison-table-module-scss-module__2Ih1RW__plan-title",
  "plan-value": "desktop-comparison-table-module-scss-module__2Ih1RW__plan-value",
  "plan-value-inner": "desktop-comparison-table-module-scss-module__2Ih1RW__plan-value-inner",
  "plan-value-outer": "desktop-comparison-table-module-scss-module__2Ih1RW__plan-value-outer",
  "row": "desktop-comparison-table-module-scss-module__2Ih1RW__row",
  "spacer": "desktop-comparison-table-module-scss-module__2Ih1RW__spacer",
  "table": "desktop-comparison-table-module-scss-module__2Ih1RW__table",
  "theme-basic": "desktop-comparison-table-module-scss-module__2Ih1RW__theme-basic",
  "theme-black": "desktop-comparison-table-module-scss-module__2Ih1RW__theme-black",
  "theme-pink": "desktop-comparison-table-module-scss-module__2Ih1RW__theme-pink",
  "theme-turquoise": "desktop-comparison-table-module-scss-module__2Ih1RW__theme-turquoise",
});
